export const getLatestRows = (data, groupByColumn, dateColumn) => {
  const grouped = {};

  // Group by the specified column
  data?.forEach((row) => {
    const key = row[groupByColumn];
    if (!grouped[key]) {
      grouped[key] = row;
    } else {
      if (new Date(row[dateColumn]) > new Date(grouped[key][dateColumn])) {
        grouped[key] = row;
      }
    }
  });

  return Object.values(grouped);
};
